import SpriteSymbol from "../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-sheet-view_category-fold",
  "use": "icon-sheet-view_category-fold-usage",
  "viewBox": "0 0 12 12",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 12 12\" id=\"icon-sheet-view_category-fold\"><g transform=\"translate(-43 -49)\" stroke=\"currentColor\" fill=\"transparent\"><rect transform=\"rotate(180 49 52)\" x=\"44.5\" y=\"50.5\" width=\"9\" height=\"3\" rx=\"1\" /><path d=\"M49.122 59.458l-4.42-3.801 8.587-.153-4.167 3.954z\" /></g></symbol>"
});
var result = sprite.add(symbol);
export default symbol